import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BackButton from "../img/icons/icon_blue_back.svg";
import { formatPID, getAgeFromDate, getFullName } from "../utils";

const ProfilePage = () => {
  const { t } = useTranslation();
  const [patientDetail, setPatientDetail] = useState({});

  //fetch past appointment
  const patientId = JSON.parse(localStorage.getItem("pid"));
  const URL = `/api/v1/users/profile/${patientId}`;
  useEffect(() => {
    const profileData = async () => {
      const token = "Bearer " + localStorage.getItem("token");
      try {
        const response = await fetch(URL, {
          method: "GET",
          headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/json",
            Authorization: token.replace(/['"]+/g, ""),
          },
          credentials: "include",
        });
        const data = await response.json();
        // console.log(data.profile);
        setPatientDetail(data.profile);
        if (!response.status === 200) {
          const error = new Error(response.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    profileData();
  }, [URL]);

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/home" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">
              {t("sidenav.MY-PROFILE.topHeading")}
            </span>
          </Link>
        </div>
      </header>
      <div className="body_content height_vh py-4">
        <div className="inner_body mt-4">
          <div className="profile_block">
            <div className="profile_thumbnail flex-column d-flex justify-content-center align-items-center">
              <div className="thumbnail d-flex justify-content-center align-items-center">
                <span className="iconprofisssle fa fa-user"></span>
                <label className="field_lbl_profile d-flex justify-content-center align-items-center">
                  <input type="file" />
                  <span className="fa fa-camera"></span>
                </label>
              </div>
              <div className="caption">
                <h3 className="subtitle">{getFullName(patientDetail)}</h3>
                <p className="desc">
                  {t("sidenav.MY-PROFILE.patientid")} :{" "}
                  {formatPID(patientDetail.patientId)}
                </p>
              </div>
            </div>
            <div className="profile_form_block">
              <ul className="list-unstyled list_profile m-2">
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.clinicId")}
                  </span>
                  <span className="txt txt_right">
                    {patientDetail.clinicId
                      ? t(
                          "onboard.TREATING_LOC.options." +
                            patientDetail.clinicId
                        )
                      : patientDetail.clinicId}
                  </span>
                </li>
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.gender")}
                  </span>
                  <span className="txt txt_right">{patientDetail.gender}</span>
                </li>
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.dob")}
                  </span>
                  <span className="txt txt_right">
                    {getAgeFromDate(patientDetail.dob)}
                  </span>
                </li>
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.mobile")}
                  </span>
                  <span className="txt txt_right">{patientDetail.mobile}</span>
                </li>
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.email")}
                  </span>
                  <span className="txt txt_right">{patientDetail.email}</span>
                </li>
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.pin")}
                  </span>
                  <span className="txt txt_right">{patientDetail.zipCode}</span>
                </li>
                <li className="p-2">
                  <span className="txt txt_left float-start">
                    {t("sidenav.MY-PROFILE.location")}
                  </span>
                  <span className="txt txt_right">
                    {patientDetail.location
                      ? patientDetail.location
                      : patientDetail.address}
                  </span>
                </li>
                <li>
                  <span>&nbsp;</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
